import React, { useState } from 'react';
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { User, LogOut, ChevronDown, Shield } from 'lucide-react';
import { ABLE_COLORS } from '../constants';

export default function UserMenu({ user, onOpenMemorySettings }) {
  const [isOpen, setIsOpen] = useState(false);
  const { logout } = useKindeAuth();

  return (
    <div style={{ position: 'relative' }}>
      {/* User button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 12px',
          background: ABLE_COLORS.neutral,
          border: `1px solid ${ABLE_COLORS.border}`,
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '14px',
          color: ABLE_COLORS.textSecondary,
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = ABLE_COLORS.hoverBg;
          e.currentTarget.style.borderColor = ABLE_COLORS.borderMedium;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = ABLE_COLORS.neutral;
          e.currentTarget.style.borderColor = ABLE_COLORS.border;
        }}
      >
        <User size={18} />
        <span>{user?.given_name || user?.email || 'User'}</span>
        <ChevronDown
          size={16}
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s'
          }}
        />
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <>
          {/* Backdrop to close menu */}
          <div
            onClick={() => setIsOpen(false)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 999
            }}
          />

          {/* Menu */}
          <div
            style={{
              position: 'absolute',
              top: 'calc(100% + 8px)',
              right: 0,
              background: ABLE_COLORS.neutral,
              border: `1px solid ${ABLE_COLORS.border}`,
              borderRadius: '8px',
              boxShadow: ABLE_COLORS.cardShadowHover,
              minWidth: '200px',
              zIndex: 1000,
              overflow: 'hidden'
            }}
          >
            {/* User info */}
            <div style={{
              padding: '12px 16px',
              borderBottom: `1px solid ${ABLE_COLORS.border}`
            }}>
              <div style={{
                fontSize: '14px',
                fontWeight: '600',
                color: ABLE_COLORS.textPrimary,
                marginBottom: '4px'
              }}>
                {user?.given_name} {user?.family_name}
              </div>
              <div style={{
                fontSize: '12px',
                color: ABLE_COLORS.textMuted
              }}>
                {user?.email}
              </div>
            </div>

            {/* Memory Settings button */}
            <button
              onClick={() => {
                setIsOpen(false);
                onOpenMemorySettings?.();
              }}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 16px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontSize: '14px',
                color: ABLE_COLORS.primary,
                textAlign: 'left',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = ABLE_COLORS.bg;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <Shield size={16} />
              <span>Memory Settings</span>
            </button>

            {/* Logout button */}
            <button
              onClick={() => logout()}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 16px',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontSize: '14px',
                color: ABLE_COLORS.semantic.error,
                textAlign: 'left',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = ABLE_COLORS.errorBg;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <LogOut size={16} />
              <span>Logout</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
}
